// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.headerTabs {\n  margin-top: 17px;\n  margin-right: 30px;\n  float: left;\n}\n.headerTabs .headerLink {\n  display: inline-block;\n  border-radius: 4px;\n  background-color: #fff;\n  color: #151515;\n  cursor: pointer;\n  padding: 8px 15px;\n  text-align: center;\n  font-size: 14px;\n}\n.headerTabs .headerLink:hover {\n  color: var(--link-hover-color);\n}\n\n/* .headerTabs .headerLink.active {\n  background-color: var(--link-color);\n  color: #fff;\n  cursor: default;\n} */\n", ""]);
// Exports
module.exports = exports;
